import React, { Component } from 'react'
import "./App.css";
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import AuthenticationButton from './components/AuthenticationButton/AuthenticationButton';
import { withAuth0 } from "@auth0/auth0-react";
import { Container, Row, Col } from 'reactstrap';

class AppAuth extends Component {

    constructor(props) {
        super(props);
        this.state = {
            app: null
        };
    }

    getToken = () => {
        this.props.auth0.getAccessTokenSilently().then(result => {
            this.setState ({
                app: <App auth0user={this.props.auth0.user} auth0={this.props.auth0.user.sub.split('|')[1]} clientToken={result} />
            })
        })
    }

    render = () => {
        const { isAuthenticated } = this.props.auth0;
        if (isAuthenticated && this.state.app == null) {
            return (
                <div className="App">
                    {this.getToken()}
                </div>
            )
        } else if (this.state.app != null) {
            return this.state.app;
        } else {
            return (
                <nav className="Nav">
                    <Container fluid>
                        <Row>
                            <Col className="text-right">
                                <AuthenticationButton />
                            </Col>
                        </Row>
                    </Container>
                </nav>
            )
        }
    }
}

export default withAuth0(AppAuth);